import Axios from 'axios';
import { request } from './_request';
import moment from 'moment';

export const getDataEv = () => {
  return (dispatch, getState) => {
    dispatch({ type: 'LOADING_EV', payload: true });

    let params = getState().evaluacionGarantias;

    const user = JSON.parse(localStorage.getItem('@@auth_user'));

    let anio =
      params.fecha == null
        ? moment().format('YYYY')
        : params.fecha.format('YYYY');
    let mes =
      params.fecha == null ? moment().format('MM') : params.fecha.format('MM');

    request
      .get('/evaluacion_garantias/indicadores', {
        params: {
          puesto: params.puesto,
          anio: anio,
          mes: mes,
          marca: params.marca,
          unidad: params.unidadNegocio,
        },
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        if (response.data.code === 0) {
          let fechaCierre = moment(response.data.result.FechaCierre);
          const fechaValida = moment(fechaCierre).isSameOrAfter(
            moment(),
            'days'
          );

          dispatch({
            type: 'SUCCESS_DATA_EV',
            payload: {
              indicadores: response.data.result.indicadores,
              calificaciones: response.data.result.calificaciones,
              fechaCierre: fechaCierre,
              fechaValida: fechaValida,
              ventasAPV: response.data.result.ventasAPV,
            },
          });
        } else {
          dispatch({
            type: 'ERROR_DATA_EV',
            payload: { message: response.data.error },
          });
        }
      })
      .catch((e) => {
        console.log(e);
        dispatch({ type: 'ERROR_DATA_EV', payload: { message: e.message } });
      });
  };
};

export const getDataAux = () => {
  //console.log('getIndicadores')

  return (dispatch, getState) => {
    dispatch({ type: 'LOADING_EO', payload: true });
    let params = getState().evaluacionOptima;

    const user = JSON.parse(localStorage.getItem('@@auth_user'));

    let anio =
      params.fecha == null
        ? moment().format('YYYY')
        : params.fecha.format('YYYY');
    let mes =
      params.fecha == null ? moment().format('MM') : params.fecha.format('MM');

    request
      .get('/evaluacion/indicadores2', {
        params: {
          puesto: params.puesto,
          anio: anio,
          mes: mes,
          marca: params.marca,
          unidad: params.unidadNegocio,
        },
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        if (response.data.code === 0) {
          dispatch({
            type: 'SUCCESS_DATA_EO_AUX',
            payload: response.data.result,
          });
        } else {
          dispatch({
            type: 'ERROR_DATA_EO',
            payload: { message: response.data.error },
          });
        }
      })
      .catch((e) => {
        dispatch({ type: 'ERROR_DATA_EO', payload: { message: e.message } });
      });
  };
};

export const changeFilter = (key, value) => {
  return (dispatch, getState) => {
    console.log(key, value);
    dispatch({
      type: 'CHANGE_FILTER_EV',
      payload: { [key]: value },
    });
  };
};

export const resetIndicador = () => {
  return (dispatch, getState) => {
    dispatch({
      type: 'RESET_DATA_INDICADOR',
      payload: true,
    });
  };
};

export const changeIndicadorValue = (col, value, ind) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'CHANGE_DATA_INDICADOR',
      payload: { indicadores: ind },
    });
  };
};

export const saveEvaluacion = () => {
  return (dispatch, getState) => {
    dispatch({ type: 'SAVE_DATA_EO', payload: true });
    let params = getState().evaluacionOptima;

    let indAux = params.indicadores;
    let anio =
      params.fecha == null
        ? moment().format('YYYY')
        : params.fecha.format('YYYY');
    let mes =
      params.fecha == null ? moment().format('MM') : params.fecha.format('MM');
    let marca = params.marca;
    let unidad = params.unidadNegocio;

    let indicadores = indAux.filter((ob) => ob.Modificado);
    //console.log('Se modificaron: ', modificados.length )
    if (indicadores.length > 0) {
      request
        .post('/evaluacion/save', { anio, mes, marca, unidad, indicadores })
        .then((response) => {
          if (response.data.result.code === 0) {
            return dispatch({
              type: 'SAVED_EO',
              payload: response.data.result,
            });
          } else {
            return dispatch({
              type: 'ERROR_SAVED_EO',
              payload: response.data.result,
            });
          }
        });
    }
  };
};

export const getPuestosPestanas = (val) => {
  const user = JSON.parse(localStorage.getItem('@@auth_user'));

  return (dispatch, getState) => {
    dispatch({ type: 'LOADING_PUESTOS', payload: true });
    request
      .get('/evaluacion_garantias/pestanas_evaluacion_garantias', {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        dispatch({ type: 'SUCCESS_PUESTOS_EV', payload: response.data.result });
      });
  };
};

export const getMarcasEv = () => {
  const user = JSON.parse(localStorage.getItem('@@auth_user'));

  return (dispatch, getState) => {
    dispatch({ type: 'LOADING_MARCAEV', payload: true });
    request
      .get('/evaluacion_garantias/marcas', {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        dispatch({ type: 'SUCCESS_MARCAS_EV', payload: response.data.result });
      });
  };
};

export const getColumnasEv = () => {
  const user = JSON.parse(localStorage.getItem('@@auth_user'));

  return (dispatch, getState) => {
    dispatch({ type: 'LOADING_COLUMNAS_EV', payload: true });
    request
      .get('/evaluacion_garantias/columnas', {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        dispatch({
          type: 'SUCCESS_COLUMNAS_EV',
          payload: response.data.result,
        });
      });
  };
};

export const get_ventas_apv = (meta, indicadores, ind) => {
  const user = JSON.parse(localStorage.getItem('@@auth_user'));

  console.log('Api', meta, indicadores[ind].Indicador);

  return (dispatch, getState) => {
    dispatch({ type: 'GET_APVS', payload: true });
    let params = getState().evaluacionOptima;
    let anio =
      params.fecha == null
        ? moment().format('YYYY')
        : params.fecha.format('YYYY');
    let mes =
      params.fecha == null ? moment().format('MM') : params.fecha.format('MM');
    request
      .get('/evaluacion/asesores', {
        params: {
          meta: meta,
          puesto: params.puesto,
          anio: anio,
          mes: mes,
          marca: params.marca,
          unidad: params.unidadNegocio,
        },
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        let cantidad = response.data.result.apvCumplen;
        let ob = indicadores[ind].Respuestas[1].Valor;
        indicadores[ind].Respuestas[2].Valor = cantidad;

        let cump = ((cantidad / ob) * 100).toFixed(2);
        indicadores[ind].Respuestas[3].Valor = cump;
        indicadores[ind].Respuestas[3].TipoValor = '%';

        dispatch({
          type: 'CHANGE_DATA_INDICADOR',
          payload: response.data.result,
        });
      });
  };
};

export const setReportesAbiertos = (data) => {
  return (dispatch, getState) => {
    const { fecha } = getState().evaluacionGarantias;
    const { unidad, marca } = data;
    const dateObject = moment(fecha);
    const user = JSON.parse(localStorage.getItem('@@auth_user'));

    const month = dateObject.format('MM'); // Obtener el nombre del mes completo (ejemplo: "July")
    const year = dateObject.format('YYYY'); // Obtener el año (ejemplo: "2023")

    Axios.get(
      `https://sygo.io/metrics/reportes/abiertos?idMarca=${marca}&idAgencia=${unidad}&month=${month}&year=${year}`,
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      }
    )
      .then((result) => {
        dispatch({
          type: 'REPORTES_ABIERTOS',
          payload: {
            reportesAbiertos: result.data.result,
            message: result.data.message,
          },
        });
      })
      .catch((e) => {
        console.log(e);
        if ([401, 403].includes(e.response.status)) {
          localStorage.clear();
          dispatch({
            type: 'ERROR_TOKEN_MAIN',
            payload: { message: e.response.data.message },
          });
          dispatch({
            type: 'ERROR_TOKEN_MAIN_METRIC',
            payload: e.response.data.message,
          });
        }
        dispatch({
          type: 'IS_ERROR',
          payload: {
            error: true,
            message: e.response.data.message,
          },
        });
      });
  };
};

export const importExcel = (data) => {
  return (dispatch, getState) => {
    const { fecha } = getState().evaluacionGarantias;
    const { file, unidad, marca } = data;
    const dateObject = moment(fecha);
    const user = JSON.parse(localStorage.getItem('@@auth_user'));

    const month = dateObject.format('MM'); // Obtener el nombre del mes completo (ejemplo: "July")
    const year = dateObject.format('YYYY'); // Obtener el año (ejemplo: "2023")

    const formData = new FormData();
    formData.append('prueba_excel', file.file);
    console.log({
      formData,
      file: file.file,
    });
    Axios.post(
      `https://sygo.io/metrics
      /testing?idMarca=${marca}&idAgencia=${unidad}&month=${month}&year=${year}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${user.token}`,
        },
      }
    )
      .then((result) => {
        console.log(result);
        dispatch({
          type: 'IS_SAVE',
          payload: {
            save: true,
            message: result.data.message,
          },
        });
      })
      .catch((e) => {
        console.log(e);
        if ([401, 403].includes(e.response.status)) {
          localStorage.clear();
          dispatch({
            type: 'ERROR_TOKEN_MAIN',
            payload: { message: e.response.data.message },
          });
          dispatch({
            type: 'ERROR_TOKEN_MAIN_METRIC',
            payload: e.response.data.message,
          });
        }
        dispatch({
          type: 'IS_ERROR',
          payload: {
            error: true,
            message: e.response.data.message,
          },
        });
      });
  };
};
